// 全局状态管理模块
// 从localStorage恢复状态
const getStoredUserInfo = () => {
  try {
    const storedUserInfo = localStorage.getItem('parq_user_info')
    if (storedUserInfo) {
      return JSON.parse(storedUserInfo)
    }
  } catch (error) {
    console.error('从localStorage恢复用户信息失败:', error)
  }
  return {
    dqUserName: '',
    clientId: '',
    institutionId: ''
  }
}

const state = {
  ...getStoredUserInfo()
}

const mutations = {
  // 设置用户姓名
  SET_DQ_USER_NAME(state, name) {
    state.dqUserName = name
    saveUserInfoToStorage(state)
  },

  // 设置客户ID
  SET_CLIENT_ID(state, id) {
    state.clientId = id
    saveUserInfoToStorage(state)
  },

  // 设置机构ID
  SET_INSTITUTION_ID(state, id) {
    state.institutionId = id
    saveUserInfoToStorage(state)
  },

  // 清空用户信息
  CLEAR_USER_INFO(state) {
    state.dqUserName = ''
    state.clientId = ''
    state.institutionId = ''
    localStorage.removeItem('parq_user_info')
  }
}

// 保存用户信息到localStorage
const saveUserInfoToStorage = (state) => {
  try {
    const userInfo = {
      dqUserName: state.dqUserName,
      clientId: state.clientId,
      institutionId: state.institutionId
    }
    localStorage.setItem('parq_user_info', JSON.stringify(userInfo))
  } catch (error) {
    console.error('保存用户信息到localStorage失败:', error)
  }
}

const actions = {
  // 设置用户信息
  setUserInfo({ commit }, userInfo) {
    if (userInfo.name) {
      commit('SET_DQ_USER_NAME', userInfo.name)
    }
    if (userInfo.clientId) {
      commit('SET_CLIENT_ID', userInfo.clientId)
    }
    if (userInfo.institutionId) {
      commit('SET_INSTITUTION_ID', userInfo.institutionId)
    }
  },

  // 清空用户信息
  clearUserInfo({ commit }) {
    commit('CLEAR_USER_INFO')
  },
  // 设置机构id
  setInstitutionId({ commit }, institutionId) {
    commit('SET_INSTITUTION_ID', institutionId)
  }
}

const getters = {
  // 获取用户姓名
  dqUserName: (state) => state.dqUserName,
  // 获取客户ID
  clientId: (state) => state.clientId,
  // 获取机构ID
  institutionId: (state) => state.institutionId,
  // 检查是否已登录
  isLoggedIn: (state) => !!state.clientId && !!state.dqUserName
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
